import React from "react";
import "./styles.scss";
import { Spin } from "antd";

const App = () => (
  <div className="fullscreen">
    <Spin size="large" />
  </div>
);
export default App;
